import WarpElement from '@warp-ds/elements-core';
import { css, html } from 'lit';
import { BasicProfileData, ProfileType } from '../../server/types.js';
import '../components/contactButtonElement.js';
import '../components/externalItemLinkElement.js';
import '../components/fixedActions.js';
import '../components/groupedActions.js';
import { orgInfo } from '../components/orgInfo.js';
import '../components/orgLinksElement.js';
import { customElement } from 'lit/decorators.js';
import { orgRegNumber } from '../components/orgRegNumber.js';
import { logo } from '../components/logo.js';

@customElement('company-profile')
export class CompanyProfile extends WarpElement {
	static styles = [
		...WarpElement.styles,
		css`
			p {
				margin: 0;
			}

			@css-placeholder-4gkdxn;
		`,
	];

	data!: BasicProfileData;
	fixedCta: boolean = false;

	static properties = {
		data: { type: Object },
		fixedCta: { type: Boolean },
	};

	connectedCallback() {
		super.connectedCallback();
	}

	render() {
		switch (this.data.profileType) {
			case ProfileType.None:
				return html`
					<div class="flex flex-col space-y-16 max-w-[400]">
						<grouped-actions
							.orgName=${this.data.orgName}
							.contactUsUrl=${this.data.contactUsUrl}
							.externalItemLink=${this.data.externalItemLink}
							.profileType=${this.data.profileType}
						></grouped-actions>
					</div>
				`;

			case ProfileType.Fixed:
				return html`
					<fixed-actions
						.adId=${this.data.adId}
						.phone=${this.data.phone}
						.orgName=${this.data.orgName}
						.contactUsUrl=${this.data.contactUsUrl}
						.externalItemLink=${this.data.externalItemLink}
						.profileType=${this.data.profileType}
					></fixed-actions>
				`;
			case ProfileType.Standard:
			default:
				return html`
					<div class="flex flex-col space-y-16 max-w-[400]">
						<grouped-actions
							.orgName=${this.data.orgName}
							.contactUsUrl=${this.data.contactUsUrl}
							.externalItemLink=${this.data.externalItemLink}
							.profileType=${this.data.profileType}
							?fixedCta=${this.fixedCta}
						></grouped-actions>
						<div class="flex flex-col border s-border rounded-8 s-bg-selected">
							<h2 class="sr-only">
								${this.i18n.t({
									id: 'companyProfile.aboutHeading',
									message: 'About the seller',
									comment: 'Screen-reader-only heading for the about section',
								})}
							</h2>
							${logo(this.data.orgName, this.data.logo)}
							<div class="p-16 space-y-20">
								${orgInfo(this.data.orgName, this.data.address)}
								<org-links
									.adId=${this.data.adId}
									.orgName=${this.data.orgName}
									.moreFromUrl=${this.data.moreFromLink}
									.phone=${this.data.phone}
									.homepageUrl=${this.data.homepageUrl}
								></org-links>
								${orgRegNumber(
									this.data.companyRegistrationNumber,
									this.data.dsaAccepted,
								)}
							</div>
						</div>
					</div>
				`;
		}
	}
}
